// extracted by mini-css-extract-plugin
module.exports = {"authModalBox":"authModalBox--26NVl","authModalTop":"authModalTop--aVN7z","authModalSlogan":"authModalSlogan--3pcRg","authModalLangagePicker":"authModalLangagePicker--2nLNa"};